<template>
  <div ref="modal" class="modal modal-calendar fade" tabindex="-1" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="input-group mx-auto">
            <div class="input-group-prepend">
              <button type="button" class="btn btn-link" data-calendar-month="previous">
                <i class="icon-arrow-left"></i>
              </button>
            </div>
            <div class="input-group-prepend">
              <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown"></button>
              <div class="dropdown-menu">
                <a href="#" class="dropdown-item" data-calendar-month="0">Janeiro</a>
                <a href="#" class="dropdown-item" data-calendar-month="1">Fevereiro</a>
                <a href="#" class="dropdown-item" data-calendar-month="2">Março</a>
                <a href="#" class="dropdown-item" data-calendar-month="3">Abril</a>
                <a href="#" class="dropdown-item" data-calendar-month="4">Maio</a>
                <a href="#" class="dropdown-item" data-calendar-month="5">Junho</a>
                <a href="#" class="dropdown-item" data-calendar-month="6">Julho</a>
                <a href="#" class="dropdown-item" data-calendar-month="7">Agosto</a>
                <a href="#" class="dropdown-item" data-calendar-month="8">Setembro</a>
                <a href="#" class="dropdown-item" data-calendar-month="9">Outubro</a>
                <a href="#" class="dropdown-item" data-calendar-month="10">Novembro</a>
                <a href="#" class="dropdown-item" data-calendar-month="11">Dezembro</a>
              </div>
            </div>
            <input type="text" class="form-control" maxlength="4" style="height: 44px">
            <div class="input-group-append">
              <button type="button" class="btn btn-link" data-calendar-month="next">
                <i class="icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <table class="table-calendar">
            <thead>
              <tr>
                <th>Do</th>
                <th>Se</th>
                <th>Te</th>
                <th>Qa</th>
                <th>Qi</th>
                <th>Se</th>
                <th>Sa</th>
              </tr>
            </thead>
          </table>
          <div class="text-center">
            <button type="button" class="btn btn-link" data-calendar-link="today">
              <i class="icon-clock"></i> hoje
            </button>
            <button type="button" class="btn btn-link" data-calendar-link="selected">
              <i class="icon-check"></i> selecionada
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="apply">
            Aplicar
          </button>
          <button type="button" class="btn btn-outline-secondary" @click="hide">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import moment from 'moment'

export default {
  name: 'Calendar',
  props: ['value'],
  mounted () {
    const today = moment().startOf('day').toDate()

    this.$calendar.calendar('date', today).on('show.bs.modal', (e) => {
      this.$calendar.calendar('date', this.value || today)
    })
  },
  methods: {
    apply () {
      this.$emit('input', this.$calendar.calendar('date'))
      this.hide()
    },
    hide () {
      $(this.$refs.modal).modal('hide')
    }
  },
  computed: {
    $calendar () {
      return $(this.$refs.modal)
    }
  }
}
</script>
